import {
  CustomProp,
  VTComponent
} from "vue-tailwind/dist/types/ComponentSettings";
import LibrarySettings from "vue-tailwind/dist/types/LibrarySettings";

enum ComponentName {
  TAlert = "TAlert",
  TCard = "TCard"
}

type PluginDefaultSettingFactoryArgs = {
  componentName: ComponentName;
  vueTailwindComponent: VTComponent;
};

type PluginSettingFactoryArgs = PluginDefaultSettingFactoryArgs & {
  props?: {
    [key: string]: CustomProp;
  };
};

const getPluginComponentSetting = ({
  componentName,
  vueTailwindComponent,
  props
}: PluginSettingFactoryArgs): LibrarySettings => {
  return {
    [componentName]: {
      component: vueTailwindComponent,
      props: {
        ...props
      }
    }
  };
};

const getPluginDefaultComponentSetting = ({
  componentName,
  vueTailwindComponent
}: PluginDefaultSettingFactoryArgs) => {
  return getPluginComponentSetting({
    componentName,
    vueTailwindComponent,
    props: {}
  });
};

export {
  ComponentName,
  getPluginComponentSetting,
  getPluginDefaultComponentSetting
};
